import { HttpResponse, http } from 'msw';

import { environment } from '../../environments/environment';

const env = { ...environment };
const module = env.services.mainPage;
const envServiceUrl = module.url;

// โครงตาม productCheerSections ใน sale-dashboard/overview จริง (dev THFAME05, 17 ก.ค. 69)
const emptyDaypartDetail = { salesAmount: 0, qty: 0, unitNameTh: 'ชิ้น', currency: 'บาท', staffDetail: [] };
const emptyStaffSalesDetail = {
  totalAmount: 0,
  totalQty: 0,
  unitNameTh: 'ชิ้น',
  currency: 'บาท',
  morningDaypartDetail: emptyDaypartDetail,
  afternoonDaypartDetail: emptyDaypartDetail
};

const productCheerSections = () => ({
  focusProducts: {
    totalAmount: 12345,
    totalQty: 321,
    unitNameTh: 'ชิ้น',
    items: [
      {
        imageUrl: '/assets/images/bao.png',
        productName: 'น้ำดื่มตราซีเจ 600 มล.',
        qty: 120,
        unitNameTh: 'ชิ้น',
        salesAmount: 840,
        mixAndMatchItems: [
          {
            imageUrl: '/assets/images/bao.png',
            productName: 'น้ำดื่มตราซีเจ 600 มล.',
            salesQuantity: 80,
            unitName: 'ชิ้น',
            salesAmount: 560
          },
          {
            imageUrl: '/assets/images/bao-logo.png',
            productName: 'น้ำดื่มตราซีเจ 1500 มล.',
            salesQuantity: 40,
            unitName: 'ชิ้น',
            salesAmount: 280
          }
        ]
      },
      {
        imageUrl: '/assets/images/tian-tian-logo.png',
        productName: 'ขนมปังโฮลวีท ซีเจ เบเกอรี่',
        qty: 45,
        unitNameTh: 'ชิ้น',
        salesAmount: 1125
      }
    ],
    staffSalesDetail: {
      totalAmount: 1965,
      totalQty: 165,
      unitNameTh: 'ชิ้น',
      currency: 'บาท',
      morningDaypartDetail: {
        salesAmount: 1200,
        qty: 100,
        unitNameTh: 'ชิ้น',
        currency: 'บาท',
        staffDetail: [
          {
            staffNo: '000101',
            staffName: 'สมชาย ใจดี',
            qty: 60,
            unitNameTh: 'ชิ้น',
            currency: 'บาท',
            salesAmount: 720
          },
          {
            staffNo: '000102',
            staffName: 'สมหญิง ขยันยิ่ง',
            qty: 40,
            unitNameTh: 'ชิ้น',
            currency: 'บาท',
            salesAmount: 480
          }
        ]
      },
      afternoonDaypartDetail: {
        salesAmount: 765,
        qty: 65,
        unitNameTh: 'ชิ้น',
        currency: 'บาท',
        staffDetail: [
          {
            staffNo: '000103',
            staffName: 'มานะ พากเพียร',
            qty: 65,
            unitNameTh: 'ชิ้น',
            currency: 'บาท',
            salesAmount: 765
          }
        ]
      }
    }
  },
  purchaseWithPurchaseProducts: {
    totalAmount: 5400,
    totalQty: 90,
    unitNameTh: 'ชิ้น',
    items: [
      {
        imageUrl: '/assets/images/bao-logo.png',
        productName: 'แก้วน้ำเก็บอุณหภูมิ (แลกซื้อ)',
        qty: 90,
        unitNameTh: 'ชิ้น',
        salesAmount: 5400,
        mixAndMatchItems: [
          {
            imageUrl: '/assets/images/bao-logo.png',
            productName: 'แก้วน้ำเก็บอุณหภูมิ สีขาว',
            salesQuantity: 50,
            unitName: 'ชิ้น',
            salesAmount: 3000
          },
          {
            imageUrl: '/assets/images/bao-logo.png',
            productName: 'แก้วน้ำเก็บอุณหภูมิ สีดำ',
            salesQuantity: 40,
            unitName: 'ชิ้น',
            salesAmount: 2400
          }
        ]
      }
    ],
    staffSalesDetail: emptyStaffSalesDetail
  },
  cafeProducts: {
    totalAmount: 3200,
    totalQty: 64,
    unitNameTh: 'ชิ้น',
    items: [
      {
        imageUrl: '/assets/images/bao.png',
        productName: 'กาแฟลาเต้เย็น บาวคาเฟ่',
        qty: 40,
        unitNameTh: 'ชิ้น',
        salesAmount: 2000,
        mixAndMatchItems: [
          {
            imageUrl: '/assets/images/bao.png',
            productName: 'กาแฟลาเต้เย็น แก้วใหญ่',
            salesQuantity: 25,
            unitName: 'ชิ้น',
            salesAmount: 1375
          },
          {
            imageUrl: '/assets/images/bao.png',
            productName: 'กาแฟลาเต้เย็น แก้วเล็ก',
            salesQuantity: 15,
            unitName: 'ชิ้น',
            salesAmount: 625
          }
        ]
      },
      {
        imageUrl: '/assets/images/tian-tian-logo.png',
        productName: 'ชาเขียวนม บาวคาเฟ่',
        qty: 24,
        unitNameTh: 'ชิ้น',
        salesAmount: 1200
      }
    ],
    staffSalesDetail: emptyStaffSalesDetail
  },
  beerProducts: {
    totalAmount: 0,
    totalQty: 0,
    unitNameTh: 'ชิ้น',
    items: [],
    staffSalesDetail: emptyStaffSalesDetail
  }
});

const rankingRow = (rank: number, storeName: string, salesAmount: number, salesQuantity: number) => ({
  rank,
  storeName,
  salesAmount,
  salesQuantity,
  unitNameTh: 'ชิ้น',
  currency: 'บาท'
});

const rankingItems = (currentRank: number | null) =>
  Array.from({ length: 10 }, (_, i) => {
    const rank = i + 1;
    const isCurrent = rank === currentRank;
    return rankingRow(
      rank,
      isCurrent ? 'ร้านอ๊ออีเขียว (สาขาเรา)' : `ร้านสาขา ${rank}`,
      5000 - rank * 250,
      500 - rank * 20
    );
  });

// จำลอง 4 state: current ติด top10 (เขียว) / current หลุด top10 (pin เทา) / ติดที่ 1 / ไม่มีข้อมูล
const storeRankingSections = () => ({
  focusProductRanking: {
    items: rankingItems(3),
    currentStoreRanking: rankingRow(3, 'ร้านอ๊ออีเขียว (สาขาเรา)', 4250, 440)
  },
  purchaseWithPurchaseRanking: {
    items: rankingItems(null),
    currentStoreRanking: rankingRow(15, 'ร้านอ๊ออีเขียว (สาขาเรา)', 1800, 120)
  },
  cafeProductRanking: {
    items: rankingItems(1),
    currentStoreRanking: rankingRow(1, 'ร้านอ๊ออีเขียว (สาขาเรา)', 4750, 480)
  },
  beerProductRanking: {
    items: [],
    currentStoreRanking: null
  }
});

const saleSummary = (target: number, actual: number) => ({
  targetAmount: target,
  actualAmount: actual,
  achievePercent: target ? Math.floor((actual / target) * 100) : 0,
  remainingAmount: Math.max(0, target - actual),
  exceedingAmount: Math.max(0, actual - target),
  morningDaypartAmount: Math.round(actual * 0.6),
  afternoonDaypartAmount: Math.round(actual * 0.4),
  status: actual >= target ? 'ACHIEVED' : 'BELOW_TARGET'
});

const dashboardOverview = () => {
  return HttpResponse.json({
    header: {
      lastUpdateDateTime: '2026-07-21T10:00:00Z',
      lastUpdateDateText: '21 ก.ค. 69',
      lastUpdateTimeText: '17:00 น.',
      currentDaypart: 'AFTERNOON',
      currentDaypartName: 'กะบ่าย',
      remainingTimeSeconds: 3600,
      remainingTimeText: '1 ชม.'
    },
    todaySummary: {
      todayDateText: '21 ก.ค. 69',
      totalBillCount: 140,
      storeSales: saleSummary(60000, 15000),
      cafeSales: saleSummary(2400, 1400),
      newMemberSummary: { targetCount: 5, actualCount: 3, morningDaypartCount: 2, afternoonDaypartCount: 1 },
      deliverySummary: { actualAmount: 2000 },
      mobileSummary: { actualAmount: 400 },
      baoSummary: { targetAmount: 1200, actualAmount: 900, status: 'BELOW_TARGET' },
      tianTianSummary: { targetAmount: 1000, actualAmount: 1100, status: 'ACHIEVED' }
    },
    weeklySummary: {
      periodStartDate: '2026-07-20',
      periodEndDate: '2026-07-26',
      periodText: '20 ก.ค.-26 ก.ค.',
      storeSales: saleSummary(330000, 300100)
    },
    monthlySummary: {
      periodStartDate: '2026-07-01',
      periodEndDate: '2026-07-31',
      periodText: '1 ก.ค.-31 ก.ค.',
      storeSales: saleSummary(1600000, 1534200),
      cafeSales: saleSummary(98958, 63747),
      cafeCupSummary: {
        targetQuantity: 3000,
        actualQuantity: 1593,
        remainingQuantity: 1407,
        exceedingQuantity: 0,
        unitName: 'แก้ว',
        status: 'BELOW_TARGET'
      }
    },
    memberMonthlySummary: {
      totalMemberCount: 517,
      storeMemberTotalCount: 1553,
      memberSales: { achievePercent: 97, salesAmount: 1489043 },
      memberBill: { achievePercent: 65, billCount: 6000 }
    },
    productCheerSections: productCheerSections(),
    storeRankingSections: storeRankingSections(),
    staffRanking: { items: [] }
  });
};

const pad = (value: number) => `${value}`.padStart(2, '0');
const toIsoDate = (date: Date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

// Monday (ISO week start) of the week `weekOffset` weeks from today, plus its Sunday.
const weekRange = (weekOffset: number) => {
  const monday = new Date();
  const isoDay = (monday.getDay() + 6) % 7; // 0 = Monday ... 6 = Sunday
  monday.setDate(monday.getDate() - isoDay + weekOffset * 7);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  return { weekStartDate: toIsoDate(monday), weekEndDate: toIsoDate(sunday) };
};

// Default: this week has a schedule (card opens a PDF), next week not yet (empty state).
// Flip `next.available` to true to preview the "file removed" error + reload flow
// (the document handler below returns 404 SS0001 for week `next`).
const shiftSchedules = () =>
  HttpResponse.json([
    { type: 'current', ...weekRange(0), available: true },
    { type: 'next', ...weekRange(1), available: false }
  ]);

const shiftScheduleDocument = ({ params }: { params: Record<string, string> }) => {
  if (params.week === 'next') {
    return HttpResponse.json(
      { code: 'SS0001', message: 'File not found in the system. Please contact the central support team.' },
      { status: 404 }
    );
  }

  return HttpResponse.json({
    signedUrl: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'
  });
};

export const handlers = [
  http.get(env.serverUrl + envServiceUrl + '/main-page/sale-dashboard/overview', dashboardOverview),
  http.get(env.serverUrl + envServiceUrl + '/stores/:storeNo/shift-schedules', shiftSchedules),
  http.get(env.serverUrl + envServiceUrl + '/stores/:storeNo/shift-schedules/:week/document', shiftScheduleDocument)
];
